/*
 * Title: Rewards/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Reward component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const RewardsPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const token = useSelector((state: any) => state.user.user?.token || null);
  const navigate = useNavigate();
  const program = location.pathname.split("/");

  const cname = program?.[1];
  const pname = program?.[2];

  useEffect(() => {

    dispatch({ type: "SET_GLOBAL_LOADER", data: true });
    const authRoutes = ["earn", "redeem", "leaderboard", "settings"];
    if (authRoutes.some((route) => location.pathname.includes(route))) {
      if (!token) {
        navigate(`${cname}/${pname}`);
      }
    }
    dispatch({ type: "SET_GLOBAL_LOADER", data: false });
  }, [token]);

  return <></>;
};

export default RewardsPage;
